import { createSelector } from '@reduxjs/toolkit'
import { AppState } from 'redux/rootReducer'
/**
 * Direct selector to the dvf state domain
 */

const selectDvfDomain = (state: AppState) => state.dvf

/**
 * Other specific selectors
 */

export const makeSelectParcelles = createSelector(
  selectDvfDomain,
  (substate) => substate.parcelles
)

export const makeSelectMutations = createSelector(
  selectDvfDomain,
  (substate) => substate.mutations
)

export const makeSelectStatusDvf = createSelector(
  selectDvfDomain,
  (substate) => substate.statusDvf
)

export const makeSelectErrorDvf = createSelector(
  selectDvfDomain,
  (substate) => substate.errorDvf
)

export const makeSelectSelectedParcelleIndex = createSelector(
  selectDvfDomain,
  (substate) => substate.selectedParcelleIndex
)

export const makeSelectStatusExportFile = createSelector(
  selectDvfDomain,
  (substate) => substate.statusExportFile
)

export const makeSelectErrorExportFile = createSelector(
  selectDvfDomain,
  (substate) => substate.errorExportFile
)

export const makeSelectExportFileBlob = createSelector(
  selectDvfDomain,
  (substate) => substate.exportFileBlob
)

/**
 * Default selector
 */

const selectDvf = createSelector(selectDvfDomain, (substate) => substate)

export default selectDvf
